import { createRouter, createWebHistory } from 'vue-router'
const routes = [
  {
    path: '/',
    name: 'container',
    component: () => import('@/views/container/index.vue'),
    props: true,
    redirect: '/',
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index.vue'),
        props: true,
        meta: {
          type: 0,
          tit: ''
        }
      },
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
        props: true,
        meta: {
          type: 1,
          tit: ''
        }
      },
      {
        path: '/list',
        name: 'list',
        component: () => import('@/views/boxList/index.vue'),
        props: true,
        meta: {
          type: 2,
          tit: '幸运宝箱'
        }
      },
      {
        path: '/open',
        name: 'open',
        component: () => import('@/views/open/index.vue'),
        props: true,
        meta: {
          type: 2,
          tit: '幸运宝箱'
        }
      },
      {
        path: '/mall',
        name: 'mall',
        component: () => import('@/views/mall/index.vue'),
        props: true,
        meta: {
          type: 1,
          tit: '饰品商城'
        }
      },

      {
        path: '/update',
        name: 'update',
        component: () => import('@/views/update/index.vue'),
        props: true,
        meta: {
          type: 2,
          tit: '枪炮升级'
        }
      },
      {
        path: '/turn',
        name: 'turn',
        component: () => import('@/views/turn/index.vue'),
        props: true,
        meta: {
          type: 2,
          tit: '幸运转盘'
        }
      },



      {
        path: '/bag',
        name: 'bag',
        component: () => import('@/views/user/bag/index.vue'),
        props: true,
        meta: {
          type: 1,
          tit: '背包'
        }
      },
      {
        path: '/records',
        name: 'records',
        component: () => import('@/views/user/records/index.vue'),
        props: true,
        meta: {
          type: 2,
          tit: '个人记录'
        }
      },
      {
        path: '/userInfo',
        name: 'userInfo',
        component: () => import('@/views/user/userInfo/index.vue'),
        props: true,
        meta: {
          type: 1,
          tit: '个人中心'
        }
      },
      {
        path: '/rule',
        name: 'rule',
        component: () => import('@/views/user/rule/index.vue'),
        props: true,
        meta: {}
      },
      {
        path: '/shareRecord',
        name: 'shareRecord',
        component: () => import('@/views/user/shareRecord/index.vue'),
        props: true,
        meta: {}
      },
      {
        path: '/bestowed',
        name: 'bestowed',
        component: () => import('@/views/user/bestowed/index.vue'),
        props: true,
        meta: {}
      },
      {
        path: '/roll',
        name: 'roll',
        component: () => import('@/views/roll/index.vue'),
        props: true,
        meta: {
          type: 2,
          tit: 'ROLL'
        }
      },
      {
        path: '/rollDetails',
        name: 'rollDetails',
        component: () => import('@/views/roll/details.vue'),
        props: true,
        meta: {
          type: 2,
          tit: 'ROLL'
        }
      },
      {
        path: '/pk',
        name: 'pk',
        component: () => import('@/views/pk/index.vue'),
        props: true,
        meta: {
          type: 2,
          tit: '决战巅峰'
        }
      },
      {
        path: '/createRoom',
        name: 'createRoom',
        component: () => import('@/views/pk/createRoom.vue'),
        props: true,
        meta: {
          type: 2,
          tit: '创建战场'
        }
      },
      {
        path: '/details',
        name: 'details',
        component: () => import('@/views/pk/details/index.vue'),
        props: true,
        meta: {
          type: 2,
          tit: '决战巅峰'
        }
      },
      {
        path: '/luck',
        name: 'luck',
        component: () => import('@/views/luck/index.vue'),
        props: true,
        meta: {}
      },
      {
        path: '/luckDetails',
        name: 'luckDetails',
        component: () => import('@/views/luck/details.vue'),
        props: true,
        meta: {}
      },
      {
        path: '/info',
        name: 'info',
        component: () => import('@/views/user/infoPage/index.vue'),
        props: true,
        meta: {}
      },
      {
        path: '/share',
        name: 'share',
        component: () => import('@/views/user/share/index.vue'),
        props: true,
        meta: {}
      },
      {
        path: '/notice',
        name: 'notice',
        component: () => import('@/views/user/notice/index.vue'),
        props: true,
        meta: {}
      },
      {
        path: '/levelBox',
        name: 'levelBox',
        component: () => import('@/views/levelBox/index.vue'),
        props: true,
        meta: {
          type: 2,
          tit: '福利'
        }
      },
      {
        path: '/pay',
        name: 'pay',
        component: () => import('@/views/pay/index.vue'),
        props: true,
        meta: {
          type: 1,
          tit: '充值'
        }
      },
    ]
  },

]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

const page = [
  '/',
  '/list',
  '/open',
  '/turn',
  '/update',
  '/pk',
  '/details',
  '/roll',
  '/rollDetails',
  '/luck',
  '/mall',
  '/bag',
  '/levelBox',
  '/pay',
  '/info',
  '/userinfo'
]

sessionStorage.setItem('pageNum', '1')
router.beforeEach(async (to, from, next) => {
  const { useUserStore } = await import('@/stores/index')
  const userStore = useUserStore()

  if (to.path !== '/login') {
    if (!sessionStorage.getItem('token')) {
      window.scrollTo(0, 0)
      next('/login')
    } else {
      let isShow = page.find(item => item == to.path)
      if (sessionStorage.getItem('pageNum') == '2' && isShow) {
        userStore.setChangePageShow(true)
        window.scrollTo(0, 0)
        // 使用Promise确保异步完成后再调用next
        await new Promise(resolve => {
          setTimeout(() => {
            resolve()
          }, 900)
        })
      } else {
        window.scrollTo(0, 0)
        // 使用Promise确保异步完成后再调用next
        await new Promise(resolve => {
          setTimeout(() => {
            sessionStorage.setItem('pageNum', '2')
            resolve()
          }, 0)
        })
      }
      next() // Promise完成后调用
    }
  } else {
    window.scrollTo(0, 0)
    userStore.setChangePageShow(true)
    next()
  }
})


export default router
